import { isDevMode } from '@angular/core';

export function getUrl(url:string) {
    let newUrl = url + '';
    if (isDevMode()) {
        if (newUrl.includes('/ibpworkbench/controller/ontology')) {
            return 'http://localhost:8080/ibpworkbench/controller/ontology';
        }
        if (newUrl.includes('inventory-manager')) {
            return 'http://localhost:8080/inventory-manager/#';
        }
        if (newUrl.includes('/ibpworkbench/main/#programs')) {
            newUrl = newUrl.replace('/ibpworkbench/main/#programs', '/app#programs');
            return newUrl;
        }
        if (newUrl.includes('/ibpworkbench/controller/jhipster')) {
            newUrl = newUrl.replace('/ibpworkbench/controller/jhipster', '/app');
            newUrl = newUrl.replace('#/', '#');
            return newUrl;
        }

    }
    return newUrl;
}
